import React from "react";
import GetIcon from "@/components/font-awesome-icon";
import Avatar from "@/components/avatar/notification";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faMessage } from "@fortawesome/free-regular-svg-icons/faMessage";
import * as styles from "./style.module.scss";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import MessageOutlined from "@mui/icons-material/MessageOutlined";

const NotificationAvatar = ({ notification }) => {
  return (
    <Avatar
      type={notification?.avatarType}
      avatar={notification?.avatar}
      classes={styles?.notificationAvatar}
      icon={
        notification?.icon === "message" ? (
          <MessageOutlined htmlColor="var(--palette-secondary_button_text)" />
        ) : (
          <EmailOutlined htmlColor="var(--palette-secondary_button_text)" />
        )
      }
      initials={notification?.initials}
      name={notification?.user?.name}
    />
  );
};

export default NotificationAvatar;
